/**
 * @generated SignedSource<<75cba76aba863cba00b5065fbbf8d548>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreProductOrder_order$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageOrderSummary_order">;
  readonly " $fragmentType": "StoreProductOrder_order";
};
export type StoreProductOrder_order$key = {
  readonly " $data"?: StoreProductOrder_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreProductOrder_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreProductOrder_order",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageOrderSummary_order"
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "7848cfe8cf130094f4f2c7e06e149b2e";

export default node;
